import React, { useEffect, useState } from 'react';
import './App.scss';
import Layout from './Layouts/Layout';
import { config } from './config';
import { cacheUtils } from './Utils/cacheUtils';
import { useLocation } from 'react-router-dom';





const app = () => {
  const isProduction = process.env.NODE_ENV === 'production';
  const location = useLocation();

  const doCachedVersionCheck = async () => {
    // console.log('doCachedVersionCheck');
    await cacheUtils.checkVersion(config.appVersion, config.versionUrl);
  };
  // implement cached version check every page navigation
  useEffect(() => {
    // console.log('location changed', { location,title, isProduction , user});
    doCachedVersionCheck();
  }, [location]);
  useEffect(() => {
    console.info('Modelcentral Loading version:', config.appVersion, process.env.NODE_ENV, { isProduction }, ' stand by...');
  }, [])


  return (
    <>
        <Layout/>
    </>

  );
};

export default app;
